import {FC} from 'react'
/* import ReferencesForm from './components/ReferencesForm'
import ReferencesCard from './components/ReferencesCard' */

const ReferencesPage: FC = () => {
  return (
    <div className='references-page'>
      <div className='references-page__container'>
        {/* <ReferencesForm /> */}

        <div className='references-page__cards'>
         {/*  <ReferencesCard /> */}
        </div>
      </div>
    </div>
  )
}

export {ReferencesPage}
